import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class NavigationStateService {
  private backNavigationSubject = new BehaviorSubject<boolean>(false);
  isBackNavigation$ = this.backNavigationSubject.asObservable();

  private internalBackSubject = new BehaviorSubject<boolean>(false);
  isInternalBack$ = this.internalBackSubject.asObservable();

  setBackNavigation(value: boolean) {
    this.backNavigationSubject.next(value);
  }

  setInternalBack(value: boolean) {
    this.internalBackSubject.next(value);
  }

  getIsBackNavigation(): boolean {
    return this.backNavigationSubject.getValue();
  }

  getIsInternalBack(): boolean {
    return this.internalBackSubject.getValue();
  }
}
